
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { Vue, Component } from 'vue-property-decorator';
const baseUrl = '20220408CBHXJ';
@Component({
  components: {
    BottomTabbar,
  },
})
export default class Rule extends Vue {
  tabs: any[] = [
    {
      title: '报名通道',
      path: `/${baseUrl}/save`,
      id: 1,
    },
    {
      title: '爆款产品',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
    {
      title: '活动信息',
      path: `/${baseUrl}/news`,
      id: 3,
    },
  ];
  activeTab = 1;
}
